import { render, staticRenderFns } from "./ProxySelector.vue?vue&type=template&id=2f1b0e56&scoped=true"
import script from "./ProxySelector.vue?vue&type=script&lang=js"
export * from "./ProxySelector.vue?vue&type=script&lang=js"
import style0 from "./ProxySelector.vue?vue&type=style&index=0&id=2f1b0e56&prod&scoped=true&lang=css"
import style1 from "./ProxySelector.vue?vue&type=style&index=1&id=2f1b0e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b0e56",
  null
  
)

export default component.exports